import React, { useState } from 'react';
import { BookOpenIcon, PenToolIcon, BookMarkedIcon, FileTextIcon, ScrollTextIcon, LibraryIcon, GiftIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface AccordionCardProps {
  title: string;
  topics: string[];
  icon: React.ReactNode;
  iconBg: string;
  isOpen: boolean;
  onToggle: () => void;
}
function AccordionCard({
  title,
  topics,
  icon,
  iconBg,
  isOpen,
  onToggle
}: AccordionCardProps) {
  return <div className={`bg-gray-50 border rounded-xl overflow-hidden transition-all duration-300 shadow-sm group cursor-pointer ${isOpen ? 'border-[#f59e0b] ring-1 ring-[#f59e0b]/30' : 'border-gray-200 hover:border-[#f59e0b]'}`} onClick={onToggle} data-id="element-226">
      <div className="p-3 sm:p-5" data-id="element-227">
        <div className="flex items-start gap-3 sm:gap-4" data-id="element-228">
          <div className={`${iconBg} w-10 h-10 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors`} data-id="element-229">
            {icon}
          </div>
          <div className="flex-1" data-id="element-230">
            <h3 className="text-sm sm:text-lg font-bold text-gray-900 leading-tight" data-id="element-231">
              {title}
            </h3>
          </div>
          <div className="text-gray-400 mt-1" data-id="element-232">
            {isOpen ? <ChevronUpIcon size={20} data-id="element-233" /> : <ChevronDownIcon size={20} data-id="element-234" />}
          </div>
        </div>

        <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100 mt-3 sm:mt-4' : 'max-h-0 opacity-0'}`} data-id="element-235">
          <div className="h-px bg-gray-200 mb-3 sm:mb-4" data-id="element-236"></div>
          <ul className="space-y-1.5 sm:space-y-2" data-id="element-237">
            {topics.map((topic, idx) => <li key={idx} className="text-xs sm:text-sm text-gray-600 flex items-start" data-id="element-238">
                <span className="text-[#f59e0b] mr-2" data-id="element-239">•</span>
                {topic}
              </li>)}
          </ul>
        </div>
      </div>
    </div>;
}
export function QueIncluye() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="que-incluye" className="py-5 sm:py-14 bg-white relative overflow-hidden" data-id="element-240">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-5" data-id="element-241">
        <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-amber-600 rounded-full blur-3xl" data-id="element-242"></div>
        <div className="absolute bottom-[-10%] left-[-5%] w-96 h-96 bg-red-600 rounded-full blur-3xl" data-id="element-243"></div>
      </div>

      <div className="max-w-6xl mx-auto px-3 sm:px-6 relative z-10" data-id="element-244">
        <div className="text-center mb-4 sm:mb-10" data-id="element-245">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2 sm:mb-4" data-id="element-246">
            ¿Qué incluye el{' '}
            <span className="text-[#f59e0b]" data-id="element-247">
              Kit Completo Lengua y Literatura Lista
            </span>
            ?
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-3xl mx-auto" data-id="element-248">
            Material completo de Lengua y Literatura organizado por año, con
            recursos prácticos y listos para aplicar en el aula.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-6 mb-4 sm:mb-10" data-id="element-249">
          <AccordionCard title="📘 KIT LENGUA Y LITERATURA – 1° AÑO" topics={['Lectura comprensiva de textos narrativos y descriptivos', 'Tipos de textos', 'Ortografía básica', 'Producción escrita: relatos breves', 'Conectores temporales', 'Vocabulario y cohesión', 'Actividades prácticas y consignas', 'Comprensión lectora', 'Producciones guiadas', 'Orientaciones docentes']} icon={<BookOpenIcon className="text-blue-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-251" />} iconBg="bg-blue-100" isOpen={openIndex === 0} onToggle={() => handleToggle(0)} data-id="element-250" />

          <AccordionCard title="📗 KIT LENGUA Y LITERATURA – 2° AÑO" topics={['Narración y descripción', 'Gramática básica', 'Ortografía', 'Producción escrita', 'Comprensión lectora', 'Textos informativos', 'Actividades prácticas', 'Proyectos breves', 'Orientaciones docentes']} icon={<PenToolIcon className="text-green-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-253" />} iconBg="bg-green-100" isOpen={openIndex === 1} onToggle={() => handleToggle(1)} data-id="element-252" />

          <AccordionCard title="📙 KIT LENGUA Y LITERATURA – 3° AÑO" topics={['Análisis de cuentos', 'Narración', 'Cohesión textual', 'Producción escrita', 'Gramática', 'Comprensión lectora', 'Actividades prácticas', 'Proyectos', 'Orientaciones docentes']} icon={<BookMarkedIcon className="text-orange-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-255" />} iconBg="bg-orange-100" isOpen={openIndex === 2} onToggle={() => handleToggle(2)} data-id="element-254" />

          <AccordionCard title="📕 KIT LENGUA Y LITERATURA – 4° AÑO" topics={['Tipos de discurso', 'Textos narrativos y no narrativos', 'Gramática avanzada', 'Ortografía', 'Producción escrita', 'Análisis literario', 'Actividades prácticas', 'Proyectos', 'Orientaciones docentes']} icon={<FileTextIcon className="text-red-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-257" />} iconBg="bg-red-100" isOpen={openIndex === 3} onToggle={() => handleToggle(3)} data-id="element-256" />

          <AccordionCard title="📓 KIT LENGUA Y LITERATURA – 5° AÑO" topics={['Textos argumentativos', 'Comprensión lectora avanzada', 'Producción escrita', 'Gramática', 'Cohesión y coherencia', 'Discurso', 'Actividades prácticas', 'Proyectos', 'Orientaciones docentes']} icon={<ScrollTextIcon className="text-purple-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-259" />} iconBg="bg-purple-100" isOpen={openIndex === 4} onToggle={() => handleToggle(4)} data-id="element-258" />

          <AccordionCard title="📔 KIT LENGUA Y LITERATURA – 6° AÑO" topics={['Análisis de textos complejos', 'Discurso social y mediático', 'Intencionalidad comunicativa', 'Producción escrita', 'Comprensión lectora', 'Cohesión textual', 'Actividades prácticas', 'Proyectos', 'Orientaciones docentes']} icon={<LibraryIcon className="text-amber-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-261" />} iconBg="bg-amber-100" isOpen={openIndex === 5} onToggle={() => handleToggle(5)} data-id="element-260" />

          <AccordionCard title="🎁 BONOS INCLUIDOS" topics={['50 actividades extra', 'Planificaciones anuales por año', 'Secuencias didácticas', 'Guía docente', 'Banco de textos', 'Antologías', 'Colección de cuentos']} icon={<GiftIcon className="text-pink-600 w-5 h-5 sm:w-7 sm:h-7" data-id="element-263" />} iconBg="bg-pink-100" isOpen={openIndex === 6} onToggle={() => handleToggle(6)} data-id="element-262" />
        </div>

        <div className="text-center" data-id="element-264">
          <button onClick={scrollToOffer} className="inline-flex items-center justify-center bg-[#16a34a] hover:bg-green-700 text-white text-sm sm:text-lg font-bold py-3 sm:py-4 px-6 sm:px-10 rounded-lg shadow-[0_4px_14px_0_rgba(22,163,74,0.39)] transition-all transform hover:scale-105 border-b-4 border-green-900 active:border-b-0 active:translate-y-0" data-id="element-265">
            🔥 QUIERO MI KIT AHORA
          </button>
        </div>
      </div>
    </section>;
}